import React, { useContext } from "react";
import AdminSupportScreen from "./components/AdminSupportScreen";
import UserSupportScreen from "./components/UserSupportScreen";
import { StateContext } from "../../store/context";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./support.theme.css";

type UserRole = "admin" | "user";

interface User {
  id: string;
  name: string;
  role: UserRole;
  email?: string;
}

const SupportSystem = () => {
  const {
    authUser: { role_name, id, fullName, email, allowed = [] },
  } = useContext(StateContext);

  const isAdmin: boolean = role_name === "admin";

  // Create user object from context
  const currentUser: User = {
    id: id?.toString() || "0",
    name: fullName || "User",
    role: isAdmin ? "admin" : "user",
    email: email || "",
  };

  return (
    <div className="vi-sup h-screen">
      {isAdmin ? (
        <AdminSupportScreen currentUser={currentUser} />
      ) : (
        <UserSupportScreen currentUser={currentUser} />
      )}
    </div>
  );
};

export default SupportSystem;
